<template>
  <section>
    <div class="holder" :class="{ active: recipientType === 'single' }">
      <!-- Single Recipient Radio Button -->
      <div :class="{ '': !recipientType || recipientType == 'multiple' }">
        <Radio-Button
          label="Ship to a single recipient"
          value="single"
          v-model="recipientType"
          customStyles="font-size: 1rem; font-weight: bold; margin-left: 1rem"
          labelStyles="margin-top: 5px"
          :isTransparent="true"
        />
      </div>

      <section v-if="recipientType === 'single'">
        <div class="">
          <section class="region-holder">
            <p class="region-holder-title">Shipping address</p>
            <div class="form-holder">
              <!-- Name Here -->
              <div class="relative">
                <input
                  autocomplete="off"
                  type="text"
                  id="name"
                  class="form-control"
                  placeholder="Full name *"
                  v-model="newRecipient.name"
                  :class="{ input__error: $v.newRecipient.name.$error }"
                  @blur="$v.newRecipient.name.$touch()"
                />
                <span
                  class="error-message-info"
                  v-if="$v.newRecipient.name.$error"
                  >{{
                    !$v.newRecipient.name.isValidRegex
                      ? 'Only latin characters are allowed.'
                      : 'Full name is required.'
                  }}
                </span>
              </div>

              <!-- Email Here -->
              <div class="relative">
                <input
                  type="email"
                  id="email"
                  placeholder="Email *"
                  v-model="newRecipient.email"
                  class="form-control"
                  :class="{ input__error: $v.newRecipient.email.$error }"
                  @blur="$v.newRecipient.email.$touch()"
                  @input="$v.newRecipient.email.$touch()"
                />
                <span
                  class="error-message-info"
                  v-if="$v.newRecipient.email.$error"
                  >{{
                    !$v.newRecipient.email.email
                      ? 'Please enter a valid email.'
                      : 'Email is required.'
                  }}</span
                >
              </div>

              <!-- Company Here -->
              <div class="relative">
                <input
                  type="text"
                  id="company"
                  v-model="newRecipient.company"
                  placeholder="company"
                  class="form-control"
                  :class="{ input__error: $v.newRecipient.company.$error }"
                  @blur="$v.newRecipient.company.$touch()"
                />
                <span
                  class="error-message-info"
                  v-if="$v.newRecipient.company.$error"
                  >{{
                    !$v.newRecipient.company.isValidRegex
                      ? 'Only latin characters are allowed.'
                      : 'Full name is required.'
                  }}
                </span>
              </div>

              <!-- Phone Here -->
              <div class="phone-group single relative">
                <vue-tel-input
                  :inputOptions="inputOptions"
                  placeholder="phone"
                  v-model="newRecipient.phone"
                  class="form-control"
                  defaultCountry="US"
                  :autoDefaultCountry="false"
                  :class="{ input__error: $v.newRecipient.phone.$error }"
                  @blur="$v.newRecipient.phone.$touch()"
                >
                  <template #arrow-icon>
                    <Dropdown />
                  </template>
                </vue-tel-input>
                <span
                  class="error-message-info"
                  v-if="$v.newRecipient.phone.$error"
                  >Phone is required.</span
                >
              </div>

              <!-- Country here -->
              <div
                class="country-holder"
                :class="{ input__error: $v.newRecipient.country.$error }"
              >
                <CountrySelect
                  :isCustom="true"
                  placeholder="select shipping country"
                  v-model="newRecipient.country"
                  :country="newRecipient.country"
                  topCountry="US"
                  :class="{ input__error: $v.newRecipient.country.$error }"
                />
              </div>

              <!-- Address One here -->
              <div class="relative">
                <input
                  type="text"
                  id="address_one"
                  name="address_one"
                  placeholder="address 1 *"
                  v-model="newRecipient.address_one"
                  @input="checkAddressLimit('newRecipient', 'address_one')"
                  class="form-control"
                  :class="{ input__error: $v.newRecipient.address_one.$error }"
                  @blur="$v.newRecipient.address_one.$touch()"
                  @input.once="handleSearchField('address_one')"
                />
                <span
                  class="error-message-info"
                  v-if="$v.newRecipient.address_one.$error"
                  >{{
                    !$v.newRecipient.address_one.isValidRegex
                      ? 'Only latin characters are allowed.'
                      : 'Address is required.'
                  }}</span
                >
              </div>

              <!-- Address two -->
              <div class="relative">
                <input
                  autocomplete="off"
                  placeholder="address 2"
                  type="text"
                  @input="handleAddressInput('newRecipient', 'address_two')"
                  id="address_two"
                  class="form-control"
                  v-model="newRecipient.address_two"
                  :class="{
                    input__error: $v.newRecipient.address_two.$error
                  }"
                />
                <span
                  class="error-message-info"
                  v-if="$v.newRecipient.address_two.$error"
                  >Only latin characters are allowed.</span
                >
              </div>

              <!-- City - state - zipcode here -->
              <div class="flex items-center">
                <!-- City Here -->
                <div class="w-1/3 relative">
                  <input
                    type="text"
                    id="city"
                    placeholder="City *"
                    class="form-control first"
                    v-model="newRecipient.city"
                    :class="{ input__error: $v.newRecipient.city.$error }"
                    @blur="$v.newRecipient.city.$touch()"
                  />
                  <span
                    class="error-message-info bottom"
                    v-if="$v.newRecipient.city.$error"
                    >{{
                      !$v.newRecipient.city.isValidRegex
                        ? 'Only latin characters are allowed.'
                        : 'City is required.'
                    }}</span
                  >
                </div>

                <!-- State Here -->
                <div
                  class="w-1/3 country-holder state"
                  :class="{ input__error: $v.newRecipient.state.$error }"
                >
                  <RegionSelect
                    placeholder=" state"
                    :isCustom="true"
                    v-model="newRecipient.state"
                    :country="newRecipient.country"
                    :region="newRecipient.state"
                    :class="{ input__error: $v.newRecipient.state.$error }"
                  />
                </div>

                <!-- Zipcode Here -->
                <div class="w-1/3 relative">
                  <input
                    type="text"
                    id="zipcode"
                    placeholder="zipcode *"
                    v-model="newRecipient.zipcode"
                    class="form-control"
                    :class="{ input__error: $v.newRecipient.zipcode.$error }"
                    @blur="$v.newRecipient.zipcode.$touch()"
                    @input="$v.newRecipient.zipcode.$touch()"
                  />
                  <span
                    class="error-message-info bottom"
                    v-if="$v.newRecipient.zipcode.$error"
                    >{{
                      !$v.newRecipient.zipcode.isValidRegex
                        ? 'Only latin characters are allowed.'
                        : 'Zipcode is required.'
                    }}</span
                  >
                </div>
              </div>
            </div>
          </section>
        </div>
        <div class="">
          <section class="region-holder rate-select">
            <p class="region-holder-title">
              Shipping options
              <img
                src="../../assets/spinner.svg"
                alt=""
                class="w-4"
                v-if="!loadStatus"
              />
            </p>
            <ShippingOptionsDropdown
              :shippingRates="shippingRates"
              :loading="!loadStatus"
              :selectedOption="selectedShippingRate"
              @handleSelection="handleShippingOptionSelect"
              :disabled="$v.newRecipient.$invalid"
            />
          </section>
          <section class="region-holder shipping-options-info">
            <div class="flex items-start gap-2">
              <img src="@/assets/info-warning.svg" />
              <span class="">
                Expedited Orders: Orders placed after 12 PM (PST time) will ship
                the next business day.
              </span>
            </div>
            <div class="flex items-start gap-2">
              <img src="@/assets/info-warning.svg" />
              <span class="">
                International Orders: Delivery dates are not guaranteed due to
                possible customs or carrier delays. We recommend ordering early
                to allow extra time.
              </span>
            </div>
          </section>
        </div>
      </section>
    </div>

    <div class="holder mt-5" :class="{ active: recipientType === 'multiple' }">
      <!-- Multiple Recipients Radio Button -->
      <div class="flex align-center flex-wrap gap-2">
        <Radio-Button
          label="Ship to multiple recipients"
          value="multiple"
          v-model="recipientType"
          customStyles="font-size: 1rem; font-weight: bold; margin-left: 1rem"
          labelStyles="margin-top: 5px"
          :disabled="!recipientList.length"
          @change="handleListCheck"
          :isTransparent="true"
        />
        <span class="multiple-recipient-info muted desktop-text">
          This feature is only applicable for items that do not have sizes.
        </span>
      </div>

      <section class="multiple-region-holder">
        <span class="multiple-recipient-info muted mobile-text">
          This feature is only applicable for items that do not have sizes.
        </span>
        <div class="multiple-recipient-info mt-5" v-if="!recipientList.length">
          <img src="../../assets/warning-2.svg" alt="" class="w-4" /> No
          Recipient Lists available. For multiple recipients, create a
          <span @click="$router.push('/recipient-list')" class="link-text"
            >Recipient List</span
          >
        </div>
        <!-- Recipient List dropdown here -->
        <div v-if="recipientType === 'multiple' && recipientList.length">
          <p class="region-holder-title">Select a recipient list</p>

          <RecipientDropdown
            :recipientList="recipientList"
            :isOrderRecipient="true"
            placeholder="Select"
          />

          <!-- Inventory Display Here  -->
          <div v-if="checkInventoryResponse.length">
            <InventoryError :checkInventoryResponse="checkInventoryResponse" />
          </div>
        </div>
      </section>
    </div>
    <!-- Button Here -->
    <div class="flex items-center justify-center next-button-holder">
      <button
        class="button-gemnote button-gemnote--small"
        :class="{
          'button-gemnote--disabled': disabledButton
        }"
        :disabled="disabledButton"
        @click="handleSubmission"
      >
        <span>{{ isEditing ? 'Save' : 'Confirm' }}</span>
      </button>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import { email, required, helpers } from 'vuelidate/lib/validators'
import RadioButton from '@/components/Universal/RadioButton'
import RecipientDropdown from './RecipientListDropdown.vue'
import ShippingOptionsDropdown from './ShippingOptionsDropdown.vue'
import InventoryError from './InventoryError.vue'
import Dropdown from '@/components/Universal/Dropdown.vue'
import CountrySelect from '@/components/CustomizedComponents/CountrySelect'
import RegionSelect from '@/components/CustomizedComponents/RegionSelect'
import AddressLimitMixin from '../../mixins/AddressLimit'
import { progressStatus } from '../../helpers'
import { debounce } from 'lodash'

// add google script
let autocomplete
const recaptchaScript = document.createElement('script')
recaptchaScript.setAttribute(
  'src',
  `https://maps.googleapis.com/maps/api/js?libraries=places&key=${process.env.VUE_APP_MAPS_API_KEY}`
)
document.head.appendChild(recaptchaScript)

export default {
  name: 'RecipientForm',
  mixins: [AddressLimitMixin],
  components: {
    RadioButton,
    RecipientDropdown,
    InventoryError,
    Dropdown,
    CountrySelect,
    RegionSelect,
    ShippingOptionsDropdown
  },

  validations: {
    newRecipient: {
      name: {
        required,
        isValidRegex: helpers.regex(
          'matches',
          /^[A-Za-z0-9äöüÄÖÜß .,?!;:'(){}[\]/\\&%@#_$*+=<>^-]+$/
        )
      },
      email: { required, email },
      company: {
        isValidRegex: helpers.regex(
          'matches',
          /^[A-Za-z0-9äöüÄÖÜß .,?!;:'(){}[\]/\\&%@#_$*+=<>^-]+$/
        )
      },
      phone: {
        required,
        isValidRegex: helpers.regex(
          'matches',
          /^\+?(\d{1,3})?[-.\s]?(\(?\d{1,4}?\)?[-.\s]?)?[\d-.\s]{3,15}$/
        )
      },
      country: {
        required
      },
      address_one: {
        required,
        isValidRegex: helpers.regex(
          'matches',
          /^[A-Za-z0-9äöüÄÖÜß .,?!;:'(){}[\]/\\&%@#_$*+=<>^-]+$/
        )
      },

      address_two: {
        isValidRegex: helpers.regex(
          'matches',
          /^[A-Za-z0-9äöüÄÖÜß .,?!;:'(){}[\]/\\&%@#_$*+=<>^-]+$/
        )
      },
      city: {
        required,
        isValidRegex: helpers.regex(
          'matches',
          /^[A-Za-z0-9äöüÄÖÜß .,?!;:'(){}[\]/\\&%@#_$*+=<>^-]+$/
        )
      },
      state: { required },
      zipcode: {
        required,
        isValidRegex: helpers.regex(
          'matches',
          /^[A-Za-z0-9äöüÄÖÜß .,?!;:'(){}[\]/\\&%@#_$*+=<>^-]+$/
        )
      }
    }
  },

  data: () => ({
    inputOptions: {
      id: 'phone',
      placeholder: 'Phone'
    },
    isFormValid: false
  }),
  created() {
    if (!this.recipientType) {
      this.$store.dispatch('recipient/setRecipientType', 'single')
    }
    this.$store.dispatch(
      'integration/getIntegrationsListForUser',
      this.$store.state.profile.user.id
    )
    this.$store.dispatch('recipient/loadRecipientList')
    if (!this.$v.newRecipient.$invalid && this.shoppingBagProducts.length) {
      this.handleRushOrder()
    } else {
      this.$store.commit('order/SET_SHIPPING_RATES', [])
      this.$store.commit('order/SET_SELECTED_SHIPPING_RATE', null)
    }
  },

  computed: {
    ...mapState({
      creatingRecipient: state => state.recipient.creatingRecipient,
      newRecipient: state => state.recipient.newRecipient,
      shoppingBagProducts: state => state.order.shoppingBagProducts,
      recipientList: state => state.recipient.recipientListRecords,
      selectedOption: state => state.recipient.orderRecipientList,
      checkInventoryResponse: state => state.order.checkInventoryResponse,
      shippingRates: state => state.order.shippingRates,
      loadingShippingRates: state => state.order.loadingShippingRates,
      selectedShippingRate: state => state.order.selectedShippingRate,
      isReplenishProducts: state => state.inventory.isReplenishProducts,
      requestEstimateCount: state => state.inventory.requestEstimateCount,
      selectedRecipientId: state => state.order.selectedRecipientId,
      shippingRateErrorOccur: state => state.order.shippingRateErrorOccur
    }),

    recipientType: {
      get() {
        return this.$store.state.recipient.recipientType
      },
      set(value) {
        this.$store.dispatch('recipient/setRecipientType', value)
      }
    },
    isEditing() {
      return parseInt(this.$route.query.editing || '') === 1
    },

    disabledButton() {
      // Handle single recipient validation
      const isSingleRecipientInvalid =
        this.recipientType === 'single' && this.$v.newRecipient.$invalid

      // Handle multiple recipient validation
      const isMultipleRecipientInvalid =
        this.recipientType === 'multiple' &&
        (!this.selectedOption.id || Boolean(this.checkInventoryResponse.length))

      // Return combined validation state
      return (
        !this.recipientType ||
        this.creatingRecipient ||
        isSingleRecipientInvalid ||
        isMultipleRecipientInvalid
      )
    },
    disablerequesEstimate() {
      return this.requestEstimateCount === 1 || this.isReplenishProducts
    },

    loadStatus() {
      return progressStatus(this.loadingShippingRates)
    }
  },

  watch: {
    ['$v.newRecipient.$invalid']: {
      handler: debounce(function(newVal) {
        this.isFormValid = !newVal
        if (!newVal) {
          this.handleNewRecipient()
        }
      }, 750),
      deep: true
    }
  },

  methods: {
    handleAddressInput(tag, key) {
      this.$v.newRecipient[key].$touch()
      this.checkAddressLimit(tag, key)
    },
    handleSearchField(selector) {
      const google = window.google
      const input = document.querySelector(`[name = ${selector}]`)

      if (input) {
        autocomplete = new google.maps.places.Autocomplete(input, {
          fields: ['formatted_address', 'address_components'],
          types: ['address']
        })

        autocomplete.addListener('place_changed', this.fillInAddress)
      }
    },

    fillInAddress() {
      if (autocomplete) {
        const place = autocomplete.getPlace()

        this.newRecipient.address_one = ''

        for (const component of place.address_components) {
          const componentType = component.types[0]

          switch (componentType) {
            case 'street_number': {
              this.newRecipient.address_one += `${component.long_name} `
              break
            }

            case 'route': {
              this.newRecipient.address_one += component.long_name
              break
            }

            case 'country': {
              this.newRecipient.country = component.short_name
              break
            }

            case 'administrative_area_level_1': {
              this.newRecipient.state = component.short_name
              break
            }

            case 'locality': {
              this.newRecipient.city = component.long_name
              break
            }

            case 'postal_code': {
              this.newRecipient.zipcode = component.long_name
              break
            }

            default: {
              break
            }
          }
        }
      }
    },

    handleSubmission() {
      if (this.recipientType === 'single') {
        this.handleSubmit()
      } else {
        this.$store.dispatch('recipient/clearRecipientObject')
        this.$store.dispatch(
          'order/checkStoreInventory',
          this.selectedOption.id
        )
      }
    },

    async handleSubmit() {
      // Handle existing recipient case
      if (this.selectedRecipientId) {
        await this.handleExistingRecipient()
        return
      }

      // Handle new recipient case
      await this.handleNewRecipient()
    },

    async handleExistingRecipient() {
      const nextRoute = this.isEditing ? 'ConfirmOrder' : 'CardMessage'
      this.$router.push({ name: nextRoute })
    },

    async handleNewRecipient() {
      // Validate recipient form
      this.$v.newRecipient.$touch()
      if (this.$v.newRecipient.$error) {
        return
      }

      // Add recipient and check rush order
      await this.$store.dispatch('recipient/addRecipient', {
        ...this.newRecipient,
        disableRouteChange: true
      })
      await this.handleRushOrder()
    },

    requestRestock() {
      this.$store.dispatch(
        'inventory/replenishProducts',
        this.checkInventoryResponse
      )
    },

    handleListCheck() {
      if (!this.recipientList.length) {
        this.$store.dispatch('notification/pushNotification', {
          type: 'error',
          messages: ['There are no available recipient lists.']
        })
      }
    },

    handleShippingOptionSelect(option) {
      this.$store.commit('order/SET_SELECTED_SHIPPING_RATE', option)
    },
    async handleRushOrder() {
      await this.$store.dispatch('order/checkRushOrder', {
        recipient_id: this.selectedRecipientId
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/global.scss';

.align-right {
  margin: 25px;
  margin-top: 5rem;

  button {
    height: 2.5rem;
    padding: 0 2rem;
  }

  @media (max-width: 767.98px) {
    margin: 0px;
  }
}

.align-center {
  align-items: center;
}
/* .button-gemnote--small {
  padding: 0 2rem;
  height: 2.5rem;
} */

.restock-buttons {
  margin: 25px;
  display: flex;
  justify-content: center;
  margin-top: 2rem;
  flex-wrap: wrap;
  gap: 0.5rem;

  button {
    padding: 0 1.75rem !important;
    font-size: 0.875rem;
    display: flex;
    justify-content: center;

    &:nth-child(1) {
      padding: 0 1.75rem !important;
      font-size: 0.875rem;
      margin-right: 0.875rem;
      border: 1px solid #000;
      color: $onyx;

      &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
      }
    }
  }
}

.next-button-holder {
  margin-top: 2rem;
  button {
    padding: 0 2.5rem !important;
    height: 3rem !important;
  }
}

.row {
  margin-top: 32px;
  display: flex;
  height: 100%;
  gap: 2rem;
  margin-bottom: 3.5rem;
}

.region-holder {
  width: 47%;
  margin-right: auto;
  margin-left: 2.3rem;

  &.shipping-options-info {
    width: 100%;
    margin-top: 0.5rem;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    img {
      width: 14px;
      height: 14px;
    }
    span {
      font-weight: 400;
      font-size: 0.68rem;
      text-align: left;
      position: relative;
      top: -1px;
    }
  }

  .region-holder-title {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    text-align: left;
    font-weight: 700;
    font-size: 0.875rem;
    margin-bottom: 1rem;
    margin-top: 1.5rem;
  }

  .form-holder {
    border: 1px solid $main-6;
    border-bottom: none;
    margin-bottom: 2.5rem;

    input {
      font-size: 0.875rem;
      font-weight: normal;
      font-family: $inter;
      padding: 0 1.5rem;
      height: 56px;

      &.input__error {
        border-bottom: 1px solid $gem-terraorange !important;
      }

      &::placeholder {
        color: #a09c95;
        font-size: 0.813rem;
        text-transform: uppercase;
      }
    }

    .country-holder {
      padding: 0.75rem 1.5rem;
      border-bottom: 1px solid $main-6;

      &.input__error {
        border-bottom: 1px solid $gem-terraorange;
      }

      &.state {
        padding: 0.469rem 0.5rem;
        border: 1px solid $main-6;
        border-top: none;

        &.input__error {
          border-bottom: 1px solid $gem-terraorange;
        }
      }
    }
  }
}

@media (max-width: 568px) {
  .region-holder {
    width: 90%;

    &.shipping-options-info {
      width: 90%;
    }
  }
}

.multiple-region-holder {
  margin-left: 2.3rem;

  .region-holder-title {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    text-align: left;
    font-weight: 700;
    font-size: 0.875rem;
    margin-bottom: 0rem;
    margin-top: 1.5rem;
  }
}

.left-column {
  flex-basis: 50%;
  background: inherit;
  border: none !important;
}

.right-column {
  flex-basis: 50%;
  background: inherit;
}

input[type='submit'] {
  float: left;
}

form {
  width: 100%;
  max-width: 25rem;
  margin: 0;
  font-family: $inter;

  .form-group {
    position: relative;

    input[type='text'] {
      height: 2.5rem;
    }

    &.required {
      margin-bottom: 1.75rem !important;
    }
  }

  .phone-group.required {
    margin-bottom: 1.75rem !important;
  }

  label {
    font-size: 1rem;
    margin-bottom: 3px !important;
  }
}

.error-icon {
  bottom: 25px;
  position: absolute;
  right: 12px;
}

.error-holder {
  position: absolute;
  text-align: left;
  font-size: 0.625rem;
  color: $gem-terraorange;
  padding-top: 5px;
  font-weight: bold;
}

input[type='text'].form-control.input__error {
  border-bottom: 1px solid $gem-terraorange !important;
}

.holder {
  padding: 1.75rem;
  border: 1px solid #dfdad2;
  border-radius: 12px;

  &.active {
    border: 1px solid #232220;
  }

  &.mt-5 {
    margin-top: 1.5rem;
  }
}

.multiple-recipient-info {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  font-size: 0.813rem;
  color: #232220;

  &.desktop-text {
    display: none;
  }

  &.muted {
    color: #514d43;
    font-size: 0.688rem;
    text-align: left;
  }

  &.mt-5 {
    margin-top: 1rem;
  }

  .link-text {
    font-weight: 700 !important;
    text-decoration: underline !important;
    cursor: pointer;
  }
}

@media (min-width: 1024px) {
  .multiple-recipient-info {
    &.desktop-text {
      display: inline-block;
    }
    &.mobile-text {
      display: none;
    }
  }
}

.mb-32 {
  margin-bottom: 2rem;
}

@media (max-width: 1100px) {
  .row {
    flex-direction: column;
  }

  form {
    max-width: 100%;
  }
}
.error-message-info {
  position: absolute;
  bottom: 0;
  right: 1%;
  font-size: 10px;
  color: #da5737;

  &.bottom {
    top: 100%;
    left: 0;
  }
}
@media (max-width: 768px) {
  .holder {
    padding: 1rem;
  }
}
</style>
